import React from 'react'
import MicroModalSelectorSearch, { CustomViewPickerRender, ResultItem } from '../../../../common/components/organisme/MicroModalSelectorSearch/MicroModalSelectorSearch';

import useQuerySelector from '../../../../common/hooks/useQuerySelector';

import { IconType } from '../../../assets/JWayIcons';



export interface MicroPickerProps {
  currentElement?: any;
  setElement: (element: any| undefined) => void;
    elementId?: string;
  style?:  React.CSSProperties;
  customViewRender?:CustomViewPickerRender;
  label?: string;
  createDefaultItem?: (value: string) => any;
  placeHolder?: string;
  searchPlaceholder?: string;
  textFormatValue: (element: any | undefined) => string;
  SearchFn: (query: string, page?: number, pageSize?: number) => Promise<any>;
  addMoreResult: (prev: any, next: any) => any;
  extractLastPageNb: (result: any) => number;
  convertResult: (result: any | undefined | null) =>  ResultItem[] | undefined | null;
  createAlwaysDefaultElement?: boolean
  sizePage?: number;
  iconTypeResultElement?: IconType;

}

export default function MicroPicker({
    currentElement,
    setElement,
    style,
    label,
    elementId,
    customViewRender,
    textFormatValue,
    placeHolder = "Sélectionner un element",
    iconTypeResultElement,
    createDefaultItem: createDefaultItemRaw,
    SearchFn,
    addMoreResult,
    extractLastPageNb,
    sizePage = 6,
    convertResult,
    createAlwaysDefaultElement,
    ...otherProps


}: MicroPickerProps) {


      const {
        resultFound,
        isLoading,
        setValueQuery,
        valueQuery,
        isLoadingMore,
        setPage,
        lastPage,
        page,
    
      } = useQuerySelector<any>({
        getSearch: SearchFn,
        addMoreResult,
        extractLastPage: extractLastPageNb,
        pageSize: sizePage,
      });

  return (
    <MicroModalSelectorSearch
    {...otherProps}
      valueSelectedName={textFormatValue(currentElement)}
      placeholder={placeHolder}
      valueQuery={valueQuery}
      setQuery={setValueQuery}
      result={
        convertResult(resultFound) || []
      }
      onClickItem={(item) => {
        setElement(item.item);
      }}
      isLoading={isLoading}
      iconType={iconTypeResultElement}
      isLoadingMore={isLoadingMore}
      setPage={setPage}
      lastPage={lastPage || undefined}
      currentPage={page}
      style={style}
      label={label}
      createAlwaysDefaultItem={createDefaultItemRaw ? true : false}
        customViewRender={customViewRender}
        createDefaultItem={createDefaultItemRaw}
        
      
   
    />
  )
}

